import { chakra, FormControl, FormLabel } from '@chakra-ui/react';
import type { SelectOption } from '@diamond/shared/types';
import { MultiSelect, reactSelectStyles } from '@diamond/shared/ui';
import type { MultiValue } from 'chakra-react-select';
import { useFormContext } from 'react-hook-form';

import { useBusinessTypes } from '../api';

type ValueMode = 'codes' | 'objects';

export function BusinessTypeInput({
  valueMode = 'codes',
}: {
  valueMode?: ValueMode;
}) {
  const { setValue, watch } = useFormContext();
  const { options, isLoading } = useBusinessTypes();

  const codesValue: string[] = (watch('business_types') as string[]) || [];
  const objectsValue: Array<{
    cg_3_business_type: string;
    cg_3_business_type_desc: string;
  }> = watch('business_types') || [];

  const selectedOptions: SelectOption[] =
    valueMode === 'codes'
      ? options.filter((opt) => codesValue.includes(opt.value))
      : options.filter((opt) =>
          Array.isArray(objectsValue)
            ? objectsValue.some((o) => o?.cg_3_business_type === opt.value)
            : false
        );

  const handleChange = (newValue: MultiValue<SelectOption>) => {
    const arr = (newValue || []) as SelectOption[];

    if (valueMode === 'codes') {
      const codes = arr.map((opt) => opt.value);
      setValue('business_types', codes, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
      return;
    }

    const objects = arr.map((opt) => ({
      cg_3_business_type: opt.value,
      cg_3_business_type_desc: opt.label,
    }));
    setValue('business_types', objects, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  return (
    <FormControl>
      <FormLabel
        aria-label="Kategori Restoran (Opsional)"
        htmlFor="business_types"
      >
        Kategori Restoran <chakra.span color="gray.75">(Opsional)</chakra.span>
      </FormLabel>
      <MultiSelect
        id="business_types"
        placeholder="Pilih Kategori Restoran"
        chakraStyles={reactSelectStyles}
        options={options}
        value={selectedOptions}
        onChange={handleChange}
        isLoading={isLoading}
        isDisabled={isLoading}
      />
    </FormControl>
  );
}
